import { z } from "zod";

export const FormSchema = z.object({
    email: z.string()
        .min(1, {
            message: "Username can not be empty.",
        }),
    password: z.string()
        .min(1, {
            message: "Password can not be empty.",
        }),
    remember: z.boolean().optional()
});